import { Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { spacings } from "themes/variables"
import PropTypes from "prop-types"

const ActionButtons = ({
  onSecondary,
  onPrimary,
  secondaryLabel,
  primaryLabel,
  primaryDisabled,
  primaryLoading,
  secondaryDisabled,
  primaryHtmlType,
  wrapperClassName,
  primaryColor,
  secondaryColor = "primary",
  primaryVariant = "solid",
  secondaryVariant = "outlined"
}) => {
  const { t } = useTranslation()
  return (
    <Flex gap={spacings.S} className={wrapperClassName}>
      <Button variant={secondaryVariant} color={secondaryColor} size="large" onClick={onSecondary} disabled={secondaryDisabled}>
        {secondaryLabel ?? t("global.cancel")}
      </Button>
      <Button
        variant={primaryVariant}
        color={primaryColor}
        size="large"
        onClick={onPrimary}
        disabled={primaryDisabled}
        loading={primaryLoading}
        htmlType={primaryHtmlType}
      >
        {primaryLabel ?? t("settings.confirm_deletion")}
      </Button>
    </Flex>
  )
}

ActionButtons.propTypes = {
  onSecondary: PropTypes.func,
  onPrimary: PropTypes.func,
  secondaryLabel: PropTypes.node,
  primaryLabel: PropTypes.node,
  primaryDisabled: PropTypes.bool,
  primaryLoading: PropTypes.bool,
  secondaryDisabled: PropTypes.bool,
  primaryHtmlType: PropTypes.oneOf(["button", "submit", "reset"]),
  wrapperClassName: PropTypes.string,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  primaryVariant: PropTypes.string,
  secondaryVariant: PropTypes.string
}

export default ActionButtons
